import { CategoryCardsGrid } from './CategoryCardsGrid.jsx';
import { CategoryDetailView } from './CategoryDetailView.jsx';

export const CategoryView = ({
  categories,
  categoryCounts,
  vendors,
  uploadingFiles,
  selectedCategory,
  onSelectCategory,
}) => {
  if (selectedCategory) {
    return (
      <CategoryDetailView
        category={selectedCategory}
        categories={categories}
        vendors={vendors}
        uploadingFiles={uploadingFiles}
      />
    );
  }

  return (
    <CategoryCardsGrid
      categories={categories}
      categoryCounts={categoryCounts}
      onSelectCategory={onSelectCategory}
    />
  );
};
